// A browser keeps one session for all its tabs (api/client.js,
// onSessionRenewed): signing in as another account in one tab, or signing
// out there, changes the session every other tab renews with. What such a
// renewal means for a tab that shows `current`.

/**
 * "switched" when the renewed session belongs to another account, "ended"
 * when the server refused the renewal (signed out elsewhere), null when
 * nothing changed for this tab or it showed no account. `renewed` is the
 * renewed session's user, null when the renewal was refused, undefined when
 * the server did not say whose it is.
 */
export function sessionChange(current, renewed) {
  if (!current?.id) return null;
  if (renewed === null) return "ended";
  if (!renewed?.id || renewed.id === current.id) return null;
  return "switched";
}

/** What the tab tells the person about the change: a title and one line. */
export function sessionChangeNotice(change, renewed) {
  if (change === "ended") {
    return {
      title: "Signed out",
      message:
        "This browser signed out in another tab, so this tab was signed out too. Sign in again to continue.",
    };
  }
  const account = renewed?.email ? `as ${renewed.email}` : "as another account";
  return {
    title: "Account changed",
    message: `This browser signed in ${account} in another tab, so this tab now shows that account. To use the pages of the account you had here, sign in as it again.`,
  };
}
